import { z } from "zod";
const Vec2Schema = z.object({
    x: z.number(),
    y: z.number(),
});
export const WorldObjectSchema = z.object({
    id: z.string().uuid(),
    kind: z.string().min(1),
    position: Vec2Schema.refine((p) => p.x >= 0 && p.x <= 1 && p.y >= 0 && p.y <= 1, { message: "Position coordinates must be normalised to [0,1]" }),
    depth: z.number(),
    scale: Vec2Schema,
    rotation: z.number(),
    flipX: z.boolean(),
    atlas: z.string().min(1),
    frame: z.string().min(1),
    tint: z.number().int().optional(),
    interactive: z.boolean().optional(),
    collides: z.boolean().optional(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const WorldObjectSpecSchema = z.array(WorldObjectSchema);
//# sourceMappingURL=worldObject.js.map